import { makeStyles } from '../../styles';

export const useDotsStyles = makeStyles([
  [
    'dots',
    (_, [vertical, size]) => [
      `
			position: absolute;
			background: transparent;
		`,
      !vertical &&
        `
			width: 100%;
			height: ${size}px;
		`,
      vertical &&
        `
			width: ${size}px;
			height: 100%;
		`
    ]
  ],
  [
    'dot',
    (theme, [vertical, size]) => [
      `
			position: absolute;
			width: ${size}px;
			height: ${size}px;
			background-color: ${theme.color.text.white};
			border: 2px solid #e8e8e8;
			border-radius: 50%;
		`,
      !vertical &&
        `
			top: -2px;
			margin-left: -${size / 2}px;
		`,
      vertical &&
        `
			left: -2px;
			margin-bottom: -${size / 2}px;
		`
    ]
  ]
]);
